import type { MouseEvent } from 'react'
import { useSetAtom } from 'jotai'
import { ListChecks } from 'lucide-react'
import { Button, Tooltip } from '@highlight/ui'
import { sidepanelOpenFocusIntentAtom, useSetSidepanelState, useSidepanelState } from '@renderer/overlay/atoms'
import { trackSidepanelOpened } from '@renderer/overlay/utils/track-sidepanel'
import { useSetSidepanelHotkeyOpened } from '@renderer/overlay/Sidepanel/atoms'
import { useViewActions, useViewNavigation } from '@renderer/overlay/Sidepanel/view-atoms'

/** Opens the sidepanel on the reminders input, the same landing as the reminders hotkey. */
export function MiniNewReminderButton() {
  const sidepanelState = useSidepanelState()
  const setSidepanelState = useSetSidepanelState()
  const setHotkeyOpened = useSetSidepanelHotkeyOpened()
  const setFocusIntent = useSetAtom(sidepanelOpenFocusIntentAtom)
  const { topView } = useViewNavigation()
  const { closeAllViews } = useViewActions()

  const handleClick = (event: MouseEvent) => {
    event.stopPropagation()
    if (topView.id !== 'reminders') {
      closeAllViews()
    }
    setFocusIntent('reminders')
    if (sidepanelState !== 'open') {
      trackSidepanelOpened('mini')
      setHotkeyOpened(true)
      setSidepanelState('open')
    }
  }

  return (
    <Tooltip>
      <Tooltip.Trigger
        render={<Button variant="ghost" size="sm" shape="square" aria-label="New reminder" onClick={handleClick} />}
      >
        <ListChecks aria-hidden="true" className="size-4" />
      </Tooltip.Trigger>
      <Tooltip.Content sideOffset={14}>New reminder</Tooltip.Content>
    </Tooltip>
  )
}
